import React, { useState, useRef, useEffect } from "react";
import Tooltip from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import CheckButton from "react-validation/build/button";
import Form from "react-validation/build/form";
import axios from 'axios';
import { useForm } from "react-hook-form";
import ContentLoader from "react-content-loader";
import { ToastContainer, toast } from 'react-toastify';
import CurrencyInput from 'react-currency-input-field';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import EditPaymentSService from "../../../../services/contract/paymentSchedule/editPaymentScheduleService";
import Helper from "../../../../Helper";
import { getTrans as t } from "../../../../Localization/translations";
import ButtonLoading from "../../../../components/Loder/buttonLoading";
import { API } from "../../../../backend";
import authHeader from "../../../../services/auth-header";
import PaymentScheduleview from "../paymentScheduleview";

function EditLoanPaymentSchedules({ paymentid, contract, contractterm, payment_rule, payment_frequency, contract_date }) {

    const [amount, setAmount] = useState("");
    const [payment_type, setPayment_type] = useState("");
    const [no_of_payments, setNo_of_payments] = useState("");
    const [frequency, setFrequency] = useState("");
    const [start_date, setStart_date] = useState("");
    const [end_date, setend_date] = useState("");
    const [successful, setSuccessful] = useState(false);
    const checkBtn = useRef();
    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    const form = useRef();
    const [loading, setLoading] = useState(false)
    const [showpaymentschedule, setShowPaymentSchedule] = useState(false)

    const payment_id = paymentid
    const contract_id = contract
    const contract_term = contractterm
    const paymentfrequency = payment_frequency
    const [feedefination, setFeeDefination] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const filterfeenature = feedefination.filter((value) => value.fee_name === payment_type)

    const FeeDefination = () => {
        // setIsLoading(true)
        let url = API + "contracts/feedefination-view/?feename=Payment Schedule&&active=Yes"
        axios.get(url, { headers: authHeader() }).then(
            response => {
                setFeeDefination(response.data);
                // setTimeout(() => {
                //     setIsLoading(false)
                // }, 1000);
            }
        )
    }

    useEffect(() => {
        FeeDefination()
    }, [])

    const validateNumberOfPayments = (value) => {
        const frequencyMapping = {
            Monthly: { months: 1 },
            Quarterly: { months: 3 },
            "Semi-annual": { months: 6 },
            Annual: { months: 12 }
        };
        const cycleDelta = frequencyMapping[paymentfrequency]
        if (payment_type === "Rent") {

            if (paymentfrequency === "Quarterly" && parseInt(value) > contract_term / cycleDelta.months) {
                return `Number of payments cannot be more than ${contract_term / cycleDelta.months} for Quarterly frequency.`;
            }
            if (paymentfrequency === "Monthly" && parseInt(value) > contract_term / cycleDelta.months) {
                return `Number of payments cannot be more than ${contract_term / cycleDelta.months} for Monthly frequency.`;
            }
            if (paymentfrequency === "Semi-annual" && parseInt(value) > contract_term / cycleDelta.months) {
                return `Number of payments cannot be more than ${contract_term / cycleDelta.months} for Semi-annual frequency.`;
            }
            if (paymentfrequency === "Annual" && parseInt(value) > contract_term / cycleDelta.months) {
                return `Number of payments cannot be more than ${contract_term / cycleDelta.months} for Annual frequency.`;
            }
            return true; // Return true for no error
        };
    }
    const handleCancel = () => {
        setShowPaymentSchedule(true)
    }
    const handelStart_Date = (value) => {
        setStart_date(value)
        reset({
            startdate: value
        })
    }
    const handleiir = () => {
        let url = API + "contracts/contractiir/?";
        url += 'id=' + contract_id
        axios.get(url, { headers: authHeader() })
            .then(response => console.log("data", response.data))
    }

    useEffect(() => {
        setIsLoading(true)
        EditPaymentSService.getPaymentSchedule(payment_id).then(
            (response) => {
                setAmount(response.data.amount)
                setFrequency(response.data.frequency)
                setStart_date(response.data.start_date)
                setend_date(response.data.end_date)
                setPayment_type(response.data.payment_type)
                setNo_of_payments(response.data.no_of_payments)
                // setTimeout(() => {
                    // }, 1000);
                reset({
                    paymentamount: response.data.amount,
                    paymenttype: response.data.payment_type,
                    frequency: response.data.frequency,
                    startdate: response.data.start_date,
                    nopayyments: response.data.no_of_payments
                })
                setIsLoading(false)
            },
        )
    }, [])

    useEffect(() => {
        setStart_date(start_date);
        const frequencyMapping = {
            Monthly: { months: 1 },
            Quarterly: { months: 3 },
            "Semi-annual": { months: 6 },
            Annual: { months: 12 }
        };
        const cycleDelta = frequencyMapping[paymentfrequency]
        // if (filterfeenature.length !== 0) {
            if (filterfeenature.length !== 0) {

                if (filterfeenature[0].fee_nature === "One Time") {
                    setNo_of_payments(1)
                    reset({
    
    
                        nopayyments: no_of_payments,
    
                    })
                }
            }
        // if (payment_type !== '') {

        //     if (payment_type === "One Time") {
        //         setNo_of_payments(1)
        //         reset({


        //             nopayyments: no_of_payments,

        //         })
        //     }
        // }
        reset({


            nopayyments: no_of_payments,

        })
        if (filterfeenature.length !== 0) {

            if (filterfeenature[0].fee_nature === "One Time") {
                setenddate(contract_term / cycleDelta.months)
            }
            else {
                setenddate(no_of_payments);
            }
        }
        // if (payment_type !== '') {

        //     if (payment_type === "One Time") {
        //         setenddate(contract_term / cycleDelta.months)
        //     }
        //     else {
        //         setenddate(no_of_payments);
        //     }
        // }
        if (payment_type === "Rent") {
            setenddate(no_of_payments);
        }
        // }
        // }, 2000)
    }, [no_of_payments, frequency,paymentfrequency, start_date, payment_type])
   
    const setenddate = (no_of_payments) => {

        if (start_date === "") {
          return false;
        }
    
        var contractDateObj = new Date(start_date);
        // Define a mapping for payment frequencies
        const frequencyMapping = {
          Monthly: { months: 1 },
          Quarterly: { months: 3 },
          "Semi-annual": { months: 6 },
          Annual: { months: 12 }
        };
        // Calculate the payment start date based on the payment rule
        let paymentStartDate, paymentEndDate;
      
        paymentEndDate = new Date(contractDateObj);
        paymentEndDate.setMonth(paymentEndDate.getMonth() + parseInt(contract_term));
        paymentEndDate.setDate(paymentEndDate.getDate() - 1);
        setend_date(paymentEndDate)
        // setPaymentStartDate(Helper.DatePicker(paymentStartDate));
      };
    // const setenddate = (no_of_payments) => {
    //     if (start_date === "") {
    //         return false;
    //     }
    //     var noofdays = 0;
    //     var dt = new Date(start_date);
    //     var newdate = new Date(dt);
    //     if (paymentfrequency === 'Weekly') {
    //         noofdays = no_of_payments * 7;
    //         newdate.setDate(newdate.getDate() + (noofdays - 1));
    //         var dd = newdate.getDate();
    //         var mm = newdate.getMonth() + 1;
    //         var y = newdate.getFullYear();
    //         var someFormattedDate = y + '-' + mm + '-' + dd;
    //         setend_date(someFormattedDate);
    //     }
    //     else if (paymentfrequency === 'Monthly') {
    //         noofdays = no_of_payments * 1;
    //         newdate.setDate(newdate.getDate() - 1);
    //         var dd = newdate.getDate();
    //         var mm = newdate.getMonth() + 1;
    //         var y = newdate.getFullYear();
    //         var someFormattedDate = y + '-' + mm + '-' + dd;
    //         // setNo_of_payments(contract_term/1)
    //         setend_date(someFormattedDate);
    //     }
    //     else if (paymentfrequency === 'Quarterly') {
    //         newdate.setDate(newdate.getDate() - 1);
    //         var dd = newdate.getDate();
    //         var mm = newdate.getMonth() + 1;
    //         var y = newdate.getFullYear();
    //         var someFormattedDate = y + '-' + mm + '-' + dd;
    //         setend_date(someFormattedDate);
    //     }
    //     else if (paymentfrequency === 'Semi-annual') {
    //         newdate.setDate(newdate.getDate() - 1);
    //         var dd = newdate.getDate();
    //         var mm = newdate.getMonth() + 1;
    //         var y = newdate.getFullYear();
    //         var someFormattedDate = y + '-' + mm + '-' + dd;
    //         setend_date(someFormattedDate);
    //     }
    //     else if (paymentfrequency === 'Annual') {
    //         newdate.setDate(newdate.getDate() - 1);
    //         var dd = newdate.getDate();
    //         var mm = newdate.getMonth() + 1;
    //         var y = newdate.getFullYear();
    //         var someFormattedDate = y + '-' + mm + '-' + dd;
    //         setend_date(someFormattedDate);
    //     }
    //     else {
    //         noofdays = 0;
    //     }
    // }

    const [disable, setDisable] = useState(false)

    const handleRegister = () => {
        setSuccessful(false);
        setLoading(true)
        setDisable(true)
        form.current.validateAll();
        if (checkBtn.current.context._errors.length === 0) {
            EditPaymentSService.addPaymentSchedule(
                payment_id,
                amount,
                frequency,
                Helper.DatePicker(start_date),
                Helper.DatePicker(end_date),
                payment_type,
                no_of_payments,
                contract_id,
            ).then(
                (response) => {
                    if (response.data.success) {
                        setSuccessful(true);
                        setLoading(false)
                        setTimeout(() => {
                            handleiir()
                            setShowPaymentSchedule(true)
                            setDisable(false)
                        }, 2000)
                        toast.success(`${response.data.response}`, {
                            position: "top-right",
                            autoClose: 1000,
                            hideProgressBar: false,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        })
                    }
                    else {
                        setLoading(false)
                        toast.error(`${response.data.error}`, {
                            position: "top-right",
                            autoClose: 1000,
                            hideProgressBar: false,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        })
                        setSuccessful(false);
                        setDisable(false)
                    }
                },
            )
        }
    }

    return (
        <>
            {
                showpaymentschedule === false ?
                    <div className="">
                        <ToastContainer />
                        <div className="header">
                            <h5 className="mb-2 pt-3 tc">{t("Edit Payment Schedules")}</h5>
                        </div>
                        <div className='card '>
                            <div className="card-body">
                                <div className="col-xl-12 ">
                                    {isLoading !== true ?
                                        <Form role="form text-left"
                                            onSubmit={handleSubmit(handleRegister)}
                                            ref={form}
                                            action="."
                                            method="POST"
                                            id="addPartyContactForm" >
                                            {(
                                                <>
                                                    <div className="form-group row">
                                                        <div className="col-xl-6">
                                                            <label className="col-lg-4 col-form-label text-left required">{t("No of Payments")} <Tooltip content={t("NoofPayments_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                            <input type="text"
                                                                className="form-control"
                                                                value={no_of_payments}
                                                                name="nopayyments"
                                                                disabled={filterfeenature.length !== 0 ? filterfeenature[0].fee_nature === "One Time" : "" ? true : false}
                                                                // disabled={payment_type ? payment_type === "One Time" : "" ? true : false}
                                                                id="payment_amount"
                                                                {...register("nopayyments", {
                                                                    onChange: (e) => setNo_of_payments(e.target.value), required: true,
                                                                    validate: (value) => validateNumberOfPayments(value) // Use custom validation
                                                                })}
                                                            />
                                                            <div className="invalid-feedback">
                                                                {errors.nopayyments?.type === 'required' && "Number of Payments  is required"}
                                                                {errors.nopayyments?.message}
                                                            </div>
                                                        </div>
                                                        <div className="col-xl-6">
                                                            <label className="col-lg-4 col-form-label text-left required">{t("Payment Amount")} <Tooltip content={t("PaymentAmount_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                            <CurrencyInput
                                                                className="form-control"
                                                                {...register("paymentamount", { required: true })}
                                                                onValueChange={(value) => setAmount(value)}
                                                                name="paymentamount"
                                                                value={amount}
                                                                id="input-example"
                                                                allowDecimals="false"
                                                                disableAbbreviations
                                                            />
                                                            <div className="invalid-feedback">
                                                                {errors.paymentamount?.type === 'required' && "Payment Amount  is required"}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group row">
                                                            <div className="col-xl-6">
                                                                <label className="col-lg-4 col-form-label text-left required">{t("Payment Type")} <Tooltip content={t("PaymentType_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                                <select
                                                                    className="form-control"
                                                                    value={payment_type}
                                                                    name="paymenttype"

                                                                    {...register("paymenttype", { onChange: (e) => { setPayment_type(e.target.value) }, required: true })} id="frequency"
                                                                >
                                                                    <option value="">{t("Payment Type")}</option>
                                                                    {/* <option value="One Time">{t("One Time")}</option>
                                                                    <option value="Recurring">{t("Recurring")}</option> */}
                                                                    {
                                                                        feedefination.map((key) => (
                                                                            <option key={key.id} value={key.fee_name}>{key.fee_name}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                                <div className="invalid-feedback">
                                                                    {errors.paymenttype && "Payment Type is required"}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-12">
                                                        <div className="form-group row">
                                                            <div className="col-xl-6">
                                                                <label className="col-lg-6 col-form-label text-left required">{t("Start Date")} <Tooltip content={t("StartDate_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                                <DatePicker
                                                                    {...register("startdate", { required: false })}
                                                                    className="form-control "
                                                                    onChange={(e) => handelStart_Date(e)}
                                                                    name="startdate"
                                                                    selected={start_date?new Date(start_date):""}
                                                                    placeholderText={"mm/dd/yyyy"}
                                                                    showYearDropdown // year show and scrolldown alos
                                                                    scrollableYearDropdown
                                                                    disabled
                                                                    showMonthDropdown
                                                                    dropdownMode="select"
                                                                />
                                                                <div className="invalid-feedback">
                                                                    {errors.startdate && "Start Date  is required"}
                                                                </div>
                                                            </div>
                                                            <div className="col-xl-6">
                                                                <label className="col-lg-6 col-form-label text-left">{t("Last Billing Date")} <Tooltip content={t("LastBillingDate_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                                <input required disabled type="text"
                                                                    value={Helper.Dateview(end_date)}
                                                                    onChange={setend_date}
                                                                    className="form-control"
                                                                    name="payment_enddate"
                                                                    id="payment_enddate"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <input type="hidden" id="paymentId" />
                                                    <div className="text-left py-3">
                                                        <button type="button" className="payment-cancel btn btn-secondary btn-md" onClick={handleCancel}>{t("Cancel")}</button>&nbsp;
                                                        <button type="submit" disabled={disable} className="updatePayment border-0 btn btn-primary btn-gradient-primary btn-md">
                                                            {
                                                                loading === false ? (
                                                                    ('Save')
                                                                ) : (
                                                                    <ButtonLoading />
                                                                )
                                                            }
                                                        </button>&nbsp;
                                                    </div>
                                                </>
                                            )}
                                            <CheckButton style={{ display: "none" }} ref={checkBtn} />
                                        </Form> :
                                        <ContentLoader
                                            viewBox="0 0 1000 550"
                                            backgroundColor="rgba(0,0,0,0.06)"
                                            foregroundColor="rgba(0,0,0,0.12)"
                                        >
                                            <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
                                            <circle cx="879" cy="123" r="11" />
                                            <circle cx="914" cy="123" r="11" />
                                            <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
                                            <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
                                            <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
                                            <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
                                            <circle cx="880" cy="184" r="11" />
                                            <circle cx="915" cy="184" r="11" />
                                            <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
                                            <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
                                            <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
                                            <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
                                            <circle cx="881" cy="242" r="11" />
                                            <circle cx="916" cy="242" r="11" />
                                            <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
                                            <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
                                            <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
                                            <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
                                            <circle cx="882" cy="303" r="11" />
                                            <circle cx="917" cy="303" r="11" />
                                            <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
                                            <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
                                            <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
                                            <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
                                            <circle cx="881" cy="363" r="11" />
                                            <circle cx="916" cy="363" r="11" />
                                            <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
                                            <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
                                            <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
                                            <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
                                            <circle cx="882" cy="424" r="11" />
                                            <circle cx="917" cy="424" r="11" />
                                            <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
                                            <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
                                            <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
                                            <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
                                            <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
                                            <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
                                            <circle cx="882" cy="484" r="11" />
                                            <circle cx="917" cy="484" r="11" />
                                            <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
                                            <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
                                            <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
                                            <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
                                            <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
                                            <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
                                            <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
                                            <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
                                            <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
                                            <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
                                        </ContentLoader>
                                    }
                                </div>
                            </div>
                        </div>
                    </div> :
                      <PaymentScheduleview
                      id={{ contract_id: contract_id, contract_start_date: start_date }}/>
                    // <PaymentScheduleList id={{ contract_id: contract_id, contract_start_date: contract_date, contract_term: contract_term }} />

            }
        </>

    )
}

export default EditLoanPaymentSchedules
